import { render } from "./BCardImg.vue?vue&type=template&id=62bc7691&ts=true"
import script from "./BCardImg.vue?vue&type=script&lang=ts"
export * from "./BCardImg.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__